import { Component, Inject, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RequestModel } from 'src/app/modules/request/requset.model';
import { ApiService } from 'src/app/Services/api.service';
import { AbstractControl, FormBuilder, FormGroup, Validators, FormArray, FormControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { COMMA, ENTER, W } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';
import { LeaveRequest, LocationRequest, OnBoardRequest, RouteChangeRequest, SiftRequest, TimeRequest, AddressUpdateRequest, RouteRequest, RouteCancelRequest,AdhocRequest, RouteLocationChangeRequest } from 'src/app/modules/request/allrequest';
import { element } from 'protractor';
declare const mapUtilityMapBox, $, Swal;
import { employeDetailsModule } from '../../../../../modules/information/employeedetails';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { MatTable } from '@angular/material/table';
import { of } from 'rxjs';
import { DatePipe } from '@angular/common';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';

export const DATE_FORMAT = {
    parse: {
        dateInput: "DD-MM-YYYY"
    },
    display: {
        dateInput: "DD/MM/YYYY",
        monthYearLabel: "MMM YYYY",
        dateA11yLabel: "DD/MM/YYYY",
        monthYearA11yLabel: "MMMM YYYY"
    }
};


export interface PeriodicElement {
    name: string;
    position: number;
    weight: number;
    symbol: string;
}


@Component({
    selector: 'add-request',
    templateUrl: './add-request.component.html',
    styleUrls: ['./add-request.component.css'],
    providers: [
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE]
        },
        { provide: MAT_DATE_FORMATS, useValue: DATE_FORMAT },
        DatePipe
    ]
})
export class AddRequestComponent {

    /* request form variables */
    requestForm: FormGroup;
    public matFormSize = '12px';
    public linearForm: boolean = true;
    public paramType = '';


    public requestType = '';

    /* request form preview */
    public leaverequset = LeaveRequest;
    public shiftRequest = SiftRequest;
    public onBoardReq = OnBoardRequest;
    public timeRequest = TimeRequest;
    public locatioRequest = LocationRequest;
    public routeChangeRequset = RouteChangeRequest;
    public addressUpdateRequest = AddressUpdateRequest
    public routeRequest = RouteRequest;
    public adhocRequest = AdhocRequest;
    public routeCancelRequest = RouteCancelRequest;
    public routelocationChangeRequest = RouteLocationChangeRequest;
     

    /* custom form field modal variables */
    public closeCustomForm: boolean = true;
    public modalName = "Add More Fields";
    public formFieldEdit: boolean = false;
    public formFieldEditIndex = -1;
    public formFieldEditData = {};

    /* custom form field table variables */
    public customFieldTableData = [];

    /* preview form fields */
    public formPreviewFields: any = [];

    /* Request form data */
    editRequestData: any;

    /* Action chipInput variable */
    actions = [];
    selectable = true;
    removable = true;
    addOnBlur = true;
    readonly separatorKeysCodes: number[] = [ENTER, COMMA];
    /* Dropdown options */
    fieldOptions = {
        whoCanReq: ['Employee', 'Driver'],
        reqTo: ['Employee', 'Driver', 'Vendor', 'Manager'],
        defaultReqTo: ['Employee', 'Driver', 'Vendor', 'Manager'],
        requestValue: [
            { value: 'custom_request', viewValue: 'Custom request' },
            { value: 'on_board_request', viewValue: 'On Board Request' },
            { value: 'location_request', viewValue: 'Location Request' },
            { value: 'route_change', viewValue: 'Route Change' },
            { value: 'route_location_change_request', viewValue: 'Route Location Change Request' },
            { value: 'time_change', viewValue: 'Time Change' },
            { value: 'shift_change', viewValue: 'Shift Change' },
            { value: 'leave_request', viewValue: 'Leave Request' },
            { value: 'address_update', viewValue: 'Address Update' },
            { value: 'route_request', viewValue: 'Route Request' },
            { value: 'route_cancel', viewValue: 'Route Cancel' },        
            { value: 'adhoc_request', viewValue: 'Adhoc Request' }],

    }
    minDate: Date;
    maxDate = new Date();
    startDateValues: any = new Date();

    isShowFrom = false;
    public cutOffPickupHideAndShow: any = ''
    public cutOffDropHideAndShow: any = ''
    public getReqType: any = '';

    submitted = false;

    editCustomRequestData: any;

    isCoustomRequest = false;

    dataSource: any;

    noFields: boolean = false;

    show: boolean;  //table show
    public typeOfRequest = 'request';
    public previewImgShow = true;

    public activeRequest: any = '';
    public employeeLocation = {};
    formSubmit:boolean=false;
    public isLocMandatory: boolean = false;
    

    constructor(
        public api: ApiService,
        public router: Router,
        public Route: ActivatedRoute,
        private fb: FormBuilder,
        private storage: StorageService,
        private route: ActivatedRoute,

        private swal: SweetAlert,
    ) {
        this.route.paramMap.subscribe((params: any) => {
            this.getReqType = params.params.requestType;
        });
    }

    ngOnInit() {
        this.requestType = this.route.snapshot.paramMap.get('requestType');
        this.requestFormLoad();
        this.reqTypeResult(this.requestType);
    }

     getLocation(obj){
    // console.log(obj);
    this.employeeLocation = {...obj};
  }
    reqTypeResult(req) {
        //alert(req)
        this.activeRequest = req;
        console.log("activeRequest=====",this.activeRequest);
        if(this.activeRequest=='route_cancel'){
            this.requestForm.addControl('bookingDays', new FormControl(2, [Validators.required,Validators.pattern('^[2-5]*$')]));
        }else{
            this.requestForm.removeControl('bookingDays');
        }

        if(['route_request','adhoc_request'].includes( this.activeRequest)){
            this.requestForm.addControl('bookingDays', new FormControl(2, [Validators.required]));
        }
        if (req ==  'custom_request') {
            this.typeOfRequest = 'customRequest';
            this.isCoustomRequest = true;
            if(this.customFieldTableData.length<=0) this.formPreviewFields = [];
            else this.formPreviewFields = this.customFieldTableData;
            this.previewImageToggle();
            this.requestForm.addControl('action', new FormControl('', Validators.required));
            this.requestForm.addControl('startDate', new FormControl('', Validators.required));
            this.requestForm.addControl('endDate', new FormControl(''));
        }
        else{
            this.typeOfRequest = 'request';
            this.isCoustomRequest = false;
            this.requestForm.removeControl('action');
            this.requestForm.removeControl('startDate');
            this.requestForm.removeControl('endDate');
            this.requstTypeValue(req);
        }
    }


    requestFormLoad() {
        this.requestForm = this.fb.group({
            title: new FormControl('', Validators.required),
            // requestTo: new FormControl('', Validators.required),
            // whomToShow: new FormControl('',Validators.required),
            requestType: new FormControl('', Validators.required),
            note: new FormControl('', [Validators.required, this.noteValidator()]),
            priority: new FormControl('',[Validators.required]),
            isActive: new FormControl(''),
            // newMenu: new FormControl(''),
            // cutOffPickup: new FormControl(''),
            // cutOffDrop:new FormControl(''),

            // New Temporary fields
            // isTemporary: [false],
            //  tempDate: [''],
            //  tempLocation: [''],
            //  transitMode: ['']

        });

//         this.requestForm.get('isTemporary')?.valueChanges.subscribe((checked: boolean) => {
//   if (!checked) {
//     console.log("uncheck form")
//     // Clear fields
//     this.submitted=false;
//     this.requestForm.patchValue({
//       tempDate: '',
//       tempLocation: '',
//       transitMode: ''
//     });
    
//             // Mark as touched so errors show immediately
//         //this.requestForm.get('tempDate')?.markAsTouched();
//         // this.requestForm.get('tempLocation')?.markAsTouched();
//         //    this.requestForm.get('transitMode')?.markAsTouched();
//   }else {
//     console.log("check form")
    
//   }
// });

    this.requestForm.get('isTemporary')?.valueChanges.subscribe((checked: boolean) => {
    if (checked) {
      this.requestForm.get('tempDate')?.setValidators([Validators.required]);
      this.requestForm.get('tempLocation')?.setValidators([Validators.required]);
      this.requestForm.get('transitMode')?.setValidators([Validators.required]);
    } else {
      this.requestForm.get('tempDate')?.clearValidators();
      this.requestForm.get('tempLocation')?.clearValidators();
      this.requestForm.get('transitMode')?.clearValidators();
    }
    this.requestForm.get('tempDate')?.updateValueAndValidity();
    this.requestForm.get('tempLocation')?.updateValueAndValidity();
    this.requestForm.get('transitMode')?.updateValueAndValidity();
  });

    }

    private noteValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const value = control.value;

            if (value === null || value === undefined || value === '') {
                return null;
            }

            if (/^\s/.test(value)) return { startsWithSpace: true };
            if (/^[0-9]/.test(value)) return { startsWithNumber: true };
            if (/^[^A-Za-z0-9\s]/.test(value)) return { startsWithSpecialCharacter: true };
            if (/  +/.test(value)) return { consecutiveSpaces: true };
            if (!/^[A-Za-z][A-Za-z0-9 _-]*$/.test(value)) return { invalidCharacters: true };

            return null;
        };
    }

    normalizeNote() {
        const noteControl = this.requestForm?.get('note');
        const value = noteControl?.value;

        if (typeof value !== 'string') return;

        const trimmedValue = value.replace(/\s+$/, '');
        if (trimmedValue !== value) {
            noteControl.setValue(trimmedValue);
        }
    }

    add(event: MatChipInputEvent): void {
        const input = event.input;
        const value = event.value;
        // Add our action list
        if ((value || '').trim()){
            this.actions.push({ name: value.trim() });
            this.requestForm.controls.action.patchValue(this.actions);
        }
        // Reset the input value
        if (input) input.value = '';
    }

    remove(val): void {
        const index = this.actions.indexOf(val);
        if (index >= 0){
            this.actions.splice(index, 1);
            this.requestForm.controls.action.patchValue(this.actions);
        }
    }

    requstTypeValue(val?) {
        this.previewImgShow = false;
        switch (val) {
            case 'location_request': this.formPreviewFields = this.locatioRequest; break;
            case 'time_change': this.formPreviewFields = this.timeRequest; break;
            case 'route_change': this.formPreviewFields = this.routeChangeRequset; break;
            case 'shift_change': this.formPreviewFields = this.shiftRequest; break;
            case 'leave_request': this.formPreviewFields = this.leaverequset; break;
            case 'on_board_request': this.formPreviewFields = this.onBoardReq; break;
            case 'address_update': this.formPreviewFields = this.addressUpdateRequest; break;
            case 'route_request': this.formPreviewFields = this.routeRequest; break;
            case 'route_cancel': this.formPreviewFields = this.routeCancelRequest; break;
            case 'adhoc_request': this.formPreviewFields = this.adhocRequest; break;
            case 'route_location_change_request': this.formPreviewFields = this.routelocationChangeRequest; break;
            default:
            // this.isLocationDiv = false
        }
        this.formLoadPreview();
    }

    // who can request field changes

    requestToValue(event) {
        let newReqsto = [];
        newReqsto = this.fieldOptions.defaultReqTo.filter(function (val) {
            const newVar = event.value.indexOf(val) == -1;
            const newVa2 = event.value.indexOf(val) != -1;
            if (newVar) {
                return newVar;
            } else {
                newReqsto.push(val);
            }
            return newVar;
        });
        this.fieldOptions.reqTo = newReqsto;
        if (this.fieldOptions.whoCanReq.length == 0 && (this.requestForm.controls['requestTo'].value.length > 0))
            this.requestForm.controls['requestTo'].patchValue('');
    }
    previewImageToggle() {
        if (this.requestForm.value.note == '' && this.requestForm.value.title == '') this.previewImgShow = true;
        else this.previewImgShow = false;
    }

    customFormFieldAdd() {
        this.modalName = 'Add More Fields';
        this.formFieldEdit = false;
        this.formFieldEditIndex = -1;
        this.formFieldEditData = {};
        this.closeCustomForm = false;
    }
    customFormFieldEdit(data, index) {
        this.modalName = 'Edit Field';
        this.formFieldEdit = true;
        this.formFieldEditIndex = index;
        this.formFieldEditData = data;
        this.closeCustomForm = false;
    }
    customFormFieldDelete(data, index) {
        Swal.fire({
            title: 'Are you sure?',
            text: 'You want to delete this field!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',//'#3085d6',
            //  cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                this.customFieldTableData.splice(index, 1);
                Swal.fire(
                    'Deleted!',
                    'field has been deleted.',
                    'success'
                );
            }
        });
    }

    formFieldResult(event) {
        this.show = false;
        this.noFields = false;
        if (!this.formFieldEdit) {
            this.customFieldTableData.push(event);
        } else {
            this.customFieldTableData[this.formFieldEditIndex] = event;
        }
        setTimeout(() => {
            this.show = true;
            this.formPreviewFields = this.customFieldTableData;
            this.formLoadPreview();
        }, 100);
    }
    formLoadPreview() {
        this.isShowFrom = false;
        setTimeout(() => {
            this.isShowFrom = true;
        }, 200);
    }



    /* Invidual form field check */
    public checkError = (controlName: string, errorName: string) => {
        return this.requestForm.controls[controlName].hasError(errorName);
    }
    requestFormValidation() {
        this.submitted = true;
    }

    showcutOffPickup(e: any) {
        this.cutOffPickupHideAndShow = e.checked;
    }
    showcutOffDrop(e: any) {
        this.cutOffDropHideAndShow = e.checked;
    }

    restrictOnlyOneNum(event: any, activeRequest: string) {
        // Handle the case for 'route_request' (1-30)
        if (['adhoc_request','route_request'].includes(activeRequest)) {
            const newValue = `${event.target.value}${event.key}`;
            // If the new value is greater than 30 or not a valid number between 1 and 30, block the input
            if (!newValue.match(/^(?:[1-9]|[12][0-9]|30)$/)) {
                event.preventDefault();
                event.stopPropagation();
                return false;
            }
        } else {
            if (!`${event.target.value}${event.key}`.match(/^[2-5]{1}$/)) {
                // Block the input if the result does not match (only 1 to 5 allowed)
                event.preventDefault();
                event.stopPropagation();
                return false;
            }
        }
    }


    onSubmit() {
        this.submitted = true;
        this.normalizeNote();
        const obj = { ...this.requestForm.value };
        obj.isActive = obj.isActive == '1' ? 1 : 0;
        obj['formFields'] = this.formPreviewFields;
        console.log("obj['formFields']>>>>>>.",obj['formFields'])
        console.log("this.activeRequest>>>>>>.",this.activeRequest)
        if (['adhoc_request','route_cancel','route_request'].includes(this.activeRequest) ) {
            let data = {
                bookingDays: this.requestForm.value.bookingDays
            }
            obj['formFields'].push(data);
        }
        obj['orgID'] = this.storage.get('userInfo').orgID;
        obj['whomToShow'] = ['Employee'];
        obj['requestTo'] = ['Manager'];
        // obj['cutOffPickup']= this.requestForm.value.cutOffPickup;
        // obj['cutOffDrop']= this.requestForm.value.cutOffDrop;
        if (this.typeOfRequest == 'customRequest') {
            if (this.customFieldTableData.length <= 0) return;
            obj.startDate = new Date(obj.startDate).getTime();
            if (obj.endDate) obj.endDate = new Date(obj.endDate).getTime();
        }
        console.log("objsssssssss",obj)
        if (this.requestForm.valid) {
            this.api.CreateRequest(obj).then((res: any) => {
                if (res.status == 'success') {
                    this.swal.swalFunction(res.status, res.status, res.message, 2000);
                    this.router.navigate(['/organization/transport-manager/request/list-request']);
                }
                if (res.status == 'failure') {
                    this.swal.swalFunction('error', res.status, res.message, 2000);
                }
            }).catch((err) => {
                console.log(err);
            });
        };   // stop here if form is invalid
    };
}



